
























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import User from '../../../store/entities/user'
@Component
export default class CreateUser extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user:User=new User();
    get roles(){
        return this.$store.state.user.roles;
    }
    save(){
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'user/create',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    validatePassCheck = (rule:any, value:any, callback:any) => {
        if (!value) {
            callback(new Error('请输入确认密码'));
        } else if (value !== this.user.password) {
            callback(new Error('确认密码与密码不匹配'));
        } else {
            callback();
        }
    };
    userRule={
        userName:[{required: true,message:'用户名不能为空',trigger: 'blur'}],
        name:[{required:true,message:'姓名不能为空',trigger: 'blur'}],
        // surname:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('Surname')),trigger: 'blur'}],
        emailAddress:[{required:true,message:'邮箱不能为空',trigger: 'blur'},{type: 'email', message: '邮箱格式错误'}],
        phoneNumber:[{required:true,message:'手机号不能为空',trigger: 'blur'}],
        position:[{required:true,message:'职位不能为空',trigger: 'blur'}],
        password:[{required:true,message:'密码不能为空',trigger: 'blur'}],
        confirmPassword:{required:true,validator: this.validatePassCheck, trigger: 'blur'}
    }
}
